export var PeerManagerEvent;
(function (PeerManagerEvent) {
    PeerManagerEvent["StartedStategy"] = "startedStrategy";
    PeerManagerEvent["DisableVideo"] = "disableVideo";
    PeerManagerEvent["Stats"] = "stats";
    PeerManagerEvent["OverAllow"] = "overAllow";
    PeerManagerEvent["ProducerStateChange"] = "producerStateChange";
    PeerManagerEvent["ProducerBadTrack"] = "producerBadTrack";
    PeerManagerEvent["ServerReloading"] = "serverReloading";
    PeerManagerEvent["Info"] = "info";
    PeerManagerEvent["FirewallIssue"] = "firewallIssue";
    PeerManagerEvent["ProduceScores"] = "produceScores";
    PeerManagerEvent["AllowedChange"] = "allowedChange";
    PeerManagerEvent["SendDebugReport"] = "debugReport";
    PeerManagerEvent["InboundBandwidthFulfillment"] = "inboundBandwidthFulfillment";
    PeerManagerEvent["StuckConnecting"] = "stuckConnecting";
    PeerManagerEvent["QualityLimitation"] = "qualityLimitation";
    PeerManagerEvent["ProducersStats"] = "producersStats";
    PeerManagerEvent["ConsumersStats"] = "consumersStats";
    PeerManagerEvent["BandwidthUtilization"] = "bandwidthUtilization";
    PeerManagerEvent["MediaConnectionStateChange"] = "mediaConnectionStateChange";
    PeerManagerEvent["CloudflareTurnResult"] = "cloudflareTurnResult";
    PeerManagerEvent["ClientIpInfo"] = "ClientIpInfo";
})(PeerManagerEvent || (PeerManagerEvent = {}));
//# sourceMappingURL=PeerManagerEvent.js.map